<template>
  <div id="block" class="view-two-block">
    <div class="title">{{ title }}</div>
    <div class="html" v-html="content" />
  </div>
</template>

<script>
export default {
  name: "Block",
  props: ["title", "content"],
}
</script>

<style scoped lang="scss">
@import "../style.scss";
</style>

<style lang="scss">
p {
  font-family: "Avenir Next Condensed", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  color: #5d5d5d;
  font-weight: normal;
}
b,
strong {
  font-weight: bold;
  font-family: "Avenir Next Condensed Demi", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  color: $black;
}
.html,
.html * {
  font-size: 0.875rem;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  b,
  strong {
    font-family: "Avenir Next Condensed Demi", "Helvetica Neue", Helvetica,
      Arial, sans-serif;
  }
  img,
  video {
    width: 100%;
    box-shadow: $deep-shadow;
    border-radius: 3px;
  }
  video {
    max-height: 300px;
    background: #353535;
  }
}
</style>
